import styled from "styled-components";
import { colors, types } from "../../../libs/themes";
import { glassMixin } from "../../../styles";

interface ScrollableListProps {
    scrollable: boolean;
}

export const ScrollableList = styled.div.withConfig({
    shouldForwardProp: (prop) => !["scrollable"].includes(prop),
})<ScrollableListProps>`
    display: flex;
    flex-direction: row;
    overflow-x: ${({ scrollable }) => (scrollable ? "scroll" : "hidden")};
    overflow-y: hidden;
    scroll-behavior: smooth;
    padding: 10px 16px 30px 10px;
    margin-bottom: 30px;
    gap: 10px;

    ${({ scrollable }) =>
        scrollable &&
        `
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const SeeAllWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;
export const MainWrapper = styled.div`
    display: flex;
    gap: 50px;
`;

export const HorizontalCardList = styled.div<{ scrollable?: boolean }>`
    display: flex;
    flex-direction: row;
    overflow-x: ${({ scrollable }) => (scrollable ? "scroll" : "hidden")};
    overflow-y: hidden;
    scroll-behavior: smooth;
    padding: 10px 0px 85px 10px;
    gap: 15px;

    ${({ scrollable }) =>
        scrollable &&
        `
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `}
`;

export const BigCardItem = styled.div`
    flex: 0 0 auto;
    width: 512px;
    height: 288px;
    display: flex;
    flex-direction: column;
`;

export const RightSectionWrapper = styled.div`
    width: 100%;
    position: relative;
    overflow: visible;
`;

export const CardTextWrapper = styled.div`
    padding: 0px 0;
`;

export const SidebarCardWrapper = styled.div`
    //padding: 10px 10px 10px 10px;
`;
export const Container = styled.div`
    padding-left: 0px;
`;

export const Title = styled.div`
    font-size: ${types.headers.main42};
    color: ${({ theme }) => theme.headingColor};
    font-weight: 600;
    margin: 0;
    line-height: normal;
    word-break: break-word;
    white-space: normal;
    max-width: 100%;

    @media (max-width: 1920px) {
        font-size: ${types.headers.main52};
    }

    @media (max-width: 1280px) {
        font-size: ${types.headers.main42};
    }

    @media (max-width: 900px) {
        font-size: ${types.headers.main36};
    }

    @media (max-width: 768px) {
        font-size: ${types.headers.main30};
    }
`;

export const Subtitle = styled.div`
    color: ${colors.background.mediumGray};
    font-size: 16px;
    margin: 0;
    line-height: 1;
    padding-left: 6px;
`;

export const CardTitle = styled.div`
    ${types.headers.itemMedium};
    line-height: normal;
    color: ${({ theme }) => theme.cardText};
    margin: 12px 0px 0px 0px;
`;

export const CardTitleText = styled.div`
    ${types.headers.itemMedium};
    line-height: normal;
    color: ${({ theme }) => theme.cardText};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    margin-bottom: 5px;
`;

export const CardSubtitleWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

export const CardSubtitleText = styled.div`
    margin: 0;
    ${types.headers.normal};

    span {
        font-weight: 400;
    }
`;

export const SeeAllCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const TitleSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 12px;
`;

export const SidebarContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

// Left arrow
export const ArrowLeft = styled.div`
    position: absolute;
    left: -20px;
    top: 30%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
    background-color: ${colors.background.white};
    border: 2px solid ${colors.border.black};
    border-radius: 50%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${glassMixin}
`;

// Right arrow
export const ArrowRight = styled.div`
    position: absolute;
    right: -20px;
    top: 30%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
    background-color: ${colors.background.white};
    border: 2px solid ${colors.border.black};
    border-radius: 50%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${glassMixin}
`;

export const BigCardSection = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ArrowWrapper = styled.div`
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
`;

export const BigCardArrowLeft = styled.div`
    position: absolute;
    left: -20px;
    top: 40%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
    background-color: ${colors.background.white};
    border: 2px solid ${colors.border.black};
    border-radius: 50%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${glassMixin}
`;

export const BigCardArrowRight = styled.div`
    position: absolute;
    right: -20px;
    top: 40%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;
    background-color: ${colors.background.white};
    border: 2px solid ${colors.border.black};
    border-radius: 50%;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${glassMixin}
`;

export const RatingWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-right: 8px;
`;

export const DirectorWrapper = styled.div`
    display: flex;
    align-items: center;
`;
